var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 14,
  viewBox: "0 0 12 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "m7 0 5 4.667V13c0 .552-.456.999-1.002.999H1.002C.45 14 0 13.55 0 12.993V1.007A1 1 0 0 1 1.003 0zM6 1H5v4.002A2 2 0 0 0 6.998 7H11V6H7c-.552 0-1-.444-1-1z"
})));
export default SvgFile;